exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".articleModal[data-v-93b8a488]{z-index:333 !important}.flex-center[data-v-93b8a488]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ellipsis1[data-v-93b8a488]{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;cursor:pointer}.responsibility-table[data-v-93b8a488]{width:100%;border-collapse:collapse}.responsibility-table th[data-v-93b8a488],.responsibility-table td[data-v-93b8a488]{border:1px solid #dcdfe6;padding:8px;text-align:center}.responsibility-table th[data-v-93b8a488]{background-color:#f5f7fa}", ""]);

// exports
